<template>
    <rkm-layout-body title="Lista de requisição">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'almoxarifado-requisicao-abertura-fechamento-create' })"
                authorize="store-almoxarifado-requisicao-abertura-fechamento"
                color="primary"
            >
                Cadastrar requisição
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/almoxarifado/requisicao-abertura-fechamento/List'

// Others.
import { mapActions } from 'vuex'
import { error } from '@/mixins'

export default {
    components: { List },
    created() {

        this.verificarSeTemMateriaisAVencer()
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        verificarSeTemMateriaisAVencer() {

            this.setLoading()

            // TODO: Finalizar após desenvolver o relatório.
            new Promise(resolve => resolve({ data: { temMateriaisAVencer: false } }))
                .then(({ data }) => {

                    if (!data.temMateriaisAVencer) return

                    this.showConfirmation(
                        `O estoque do seu setor possui materiais que irão vencer dentro de um período de 90 dias.
                            Deseja visualizar estes materiais?`,
                        async () => {

                            // this.$router.push({ name: 'almoxarifado-relatorio-materiais-vencer-index' })
                        }
                    )
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [error]
}
</script>